export const formatName = (value: string): string => {
  return value
    .toLowerCase()
    .replace(/(^|[\s'\u2019-])(\p{L})/gu, (_, separator: string, letter: string) => {
      return separator + letter.toUpperCase();
    });
};